import { render, staticRenderFns } from "./DesignComponentsModal.vue?vue&type=template&id=f0156638&scoped=true"
import script from "./DesignComponentsModal.vue?vue&type=script&lang=js"
export * from "./DesignComponentsModal.vue?vue&type=script&lang=js"
import style0 from "./DesignComponentsModal.vue?vue&type=style&index=0&id=f0156638&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0156638",
  null
  
)

/* custom blocks */
import block0 from "./DesignComponentsModal.vue?vue&type=custom&index=0&blockType=i18n&locale=ko"
if (typeof block0 === 'function') block0(component)

export default component.exports